export const TOP_SECTION_BRANDS = [
  {
    id: 'vogue',
    pathDesktop: 'find-an-event/logotypes_vogue.png',
    pathMobile: 'find-an-event/logotypes_vogue_mobile.png',
    style: {
      mobile: {
        height: '42px',
      },
    },
  },
  {
    id: 'newYorkTimes',
    pathDesktop: 'find-an-event/logotypes_new_york_times.png',
    pathMobile: 'find-an-event/logotypes_the_new_york_times_mobile.png',
    style: {
      mobile: {
        height: '42px',
      },
    },
  },
  {
    id: 'techcrunch',
    pathDesktop: 'find-an-event/logotypes_tech_crunch.png',
    pathMobile: 'find-an-event/logotypes_techcrunch_mobile.png',
    style: {
      mobile: {
        height: '44px',
      },
    },
  },
  {
    id: 'bustle',
    pathDesktop: 'find-an-event/logotypes_bustle.png',
    pathMobile: 'find-an-event/logotypes_bustle_mobile.png',
    style: {
      mobile: {
        height: '44px',
      },
    },
  },
];

export const BOTTOM_SECTION_BRANDS = [
  {
    id: 'refinery',
    pathDesktop: 'find-an-event/logotypes_refinery29.png',
    pathMobile: 'find-an-event/logotypes_refinery29_mobile.png',
    style: {
      mobile: {
        height: '40px',
      },
    },
  },
  {
    id: 'huffington',
    pathDesktop: 'find-an-event/logotypes_the_huffington_post.png',
    pathMobile: 'find-an-event/logotypes_the_huffington_post_mobile.png',
    style: {
      mobile: {
        height: '54px',
      },
    },
  },
  {
    id: 'mashable',
    pathDesktop: 'find-an-event/logotypes_mashable.png',
    pathMobile: 'find-an-event/logotypes_mashable_mobile.png',
    style: {
      mobile: {
        height: '28px',
      },
    },
  },
  {
    id: 'brides',
    pathDesktop: 'find-an-event/logotypes_brides.png',
    pathMobile: 'find-an-event/logotypes_brides_mobile.png',
    style: {
      mobile: {
        height: '40px',
      },
    },
  },
];
